export enum PublicType {
  Public = 0,
  Intranet = 1
}
